import SessionEventProto from "../session-event-proto";

import {SESSION_PROJECT_NEW, SESSION_PROJECTS_CHANGED} from "../../gd/bus/bus-event-type"
import ProjectSession from "../../model2/project/project-session"
import asyncSessionLoader from "../../gd/data/async-session-loader"
import InternalDatabase from "../../model2/databases/internal-database"
import {ProjectSystemType} from "../../model2/project/types"

// const debug = "EventProjectNew"
const debug = false

// gd.session.projects triggers events ... slow
// session loader proveryaem
// gd.tree.reset ... slow

export default class SessionProjectNew extends SessionEventProto {

    public header: {
        project     : any
        isBulkUpdate: boolean
    }

    constructor(sessionEvent: any) {
        super(sessionEvent)
        this.header     = {
            project     : sessionEvent.project,
            isBulkUpdate: sessionEvent.isBulkUpdate,
        }
    }

    async process() {
        if (this.isDifferentCompany()) return false;

        if (this.data.isTemplate && !this.data.parentId) {
            // !this.data.parentId = not subfolder in template
            const newTemplateModel = new ProjectSession(this.data)
            if (!gd.session.projects.get(newTemplateModel.id)) {
                gd.session.templatesList.add(newTemplateModel)
                newTemplateModel.initTree(gd.session.templatesList)
            }
        }

        // TEMPORARY FIX: there should be no settings data (is present on project restore)
        delete this.data.settings

        const newModel = new ProjectSession(this.data)
        if (!gd.session.projects.get(newModel.id)) {
            gd.session.projects.add(newModel)

            if (newModel.systemType === ProjectSystemType.DATABASE_INTERNAL) {
                gd.databases.addInternalDB(new InternalDatabase(newModel))
            }

            // zachem eto ?
            const sessionProject = gd.session.projects.get(this.data.id);
            if (sessionProject) {
                sessionProject.applyDelta({
                    taskStatusesOverride: this.data.taskStatusesOverride //somehow without it taskStatusesOverride is empty
                })
            }

            let statuses = newModel.taskStatusesOverride ? newModel.taskStatusesOverride : [];

            await asyncSessionLoader(gd.session.findMissing({
                projectsWithParents: [newModel.id],
                statuses: statuses
            }))

            newModel.initTree()

            gd.modelBus.newUpdate('project', this.method, this.header.project.id, this.data, this.header);
            gd.bus.triggerEvent(SESSION_PROJECTS_CHANGED)

            if (newModel.isWorkspace) {
                gd.spaces.workspaces.initFromSession()
                gd.spaces.workspaces.getByProjectId(newModel.id)?.initNavigation()
            }
            gd.bus.triggerEvent(SESSION_PROJECT_NEW, newModel)

            if (!newModel.isTemplate && gd.tree) { // there is a chance when there is no tree when new user creates new company (!) so we skip it in here!
                gd.tree.resetCompanyProjects(newModel.companyId);
            }

            if (newModel.isTag) {
                gd.fields.resetTagsFields()
            }
        }
    }
}